/**
 * Created by jonas on 2021-03-12.
 */
import * as PIXI from "pixi.js";
import {CustomWiggle} from "gsap/dist/CustomWiggle";
import {Linear} from "gsap";
import {CustomEase} from "gsap/dist/CustomEase";

export class DasUBootStatics {

    public static symbolValues:{[key:string]:{3:number, 4:number, 5:number, 6:number}} = {
        "B":{"3":0, "4":0, "5":0, "6":0},
        "L1":{"3":6, "4":9, "5":20, "6":70},
        "L2":{"3":6, "4":9, "5":18, "6":70},
        "L3":{"3":5, "4":8, "5":17, "6":50},
        "L4":{"3":5, "4":7, "5":15, "6":50},
        "L5":{"3":5, "4":6, "5":13, "6":35},
        "M":{"3":0, "4":0, "5":0, "6":0},
        "M1":{"3":22, "4":75, "5":150, "6":500},
        "M2":{"3":10, "4":15, "5":80, "6":250},
        "M3":{"3":8, "4":13, "5":40, "6":120},
        "M4":{"3":7, "4":12, "5":30, "6":100},
        "M5":{"3":7, "4":10, "5":22, "6":80},
        "S":{"3":0, "4":0, "5":0, "6":0},
        "W":{"3":0, "4":0, "5":0, "6":0},
        "X":{"3":0, "4":0, "5":0, "6":0},
    }

    public static defaultGameAreaSize:number[] = [2, 3, 4, 4, 3, 2];
    public static freespinGameAreaSize:number[] = [2, 3, 8, 4, 3, 2];

    public static firstWinHighlightReel:number = 2;

    public static symbolWidth:number = 144;
    public static symbolHeight:number = 144;
    public static symbolPeriscopeHeight:number = 108;
    public static stepDuration:number = 0.04;
    public static reelStopDelay:number = DasUBootStatics.stepDuration * 9;
    public static reelStopDelayFastSpin:number = DasUBootStatics.stepDuration * 6;
    public static reelStopDelayQuickStop:number = DasUBootStatics.stepDuration * 2;

    public static reelPositions:PIXI.Point[] = [
        new PIXI.Point(DasUBootStatics.symbolWidth * 0, DasUBootStatics.symbolHeight * 1.5),
        new PIXI.Point(DasUBootStatics.symbolWidth * 1, DasUBootStatics.symbolHeight * 1),
        new PIXI.Point(DasUBootStatics.symbolWidth * 2, DasUBootStatics.symbolHeight * 0),
        new PIXI.Point(DasUBootStatics.symbolWidth * 3, DasUBootStatics.symbolHeight * 0),
        new PIXI.Point(DasUBootStatics.symbolWidth * 4, DasUBootStatics.symbolHeight * 1),
        new PIXI.Point(DasUBootStatics.symbolWidth * 5, DasUBootStatics.symbolHeight * 1.5)
    ];

    public static lowWinSymbols:string[] = [
        "L1",
        "L2",
        "L3",
        "L4",
        "L5",
    ]
    public static midWinSymbols:string[] = [
        "M1",
        "M2",
        "M3",
        "M4",
        "M5",
    ]

    public static highWinSymbols:string[] = [
        "B",
        "M",
        "S",
        "W",
        "T",
        "P"
    ]

    //Easing
    public static bombShakeWiggleX = CustomWiggle.create("bombShakeWiggleX", {
        wiggles:20,
        amplitudeEase:Linear.easeNone,
        timingEase:Linear.easeNone,
    });

    public static bombShakeWiggleY = CustomWiggle.create("bombShakeWiggleY", {
        wiggles:15,
        amplitudeEase:Linear.easeNone,
        timingEase:Linear.easeNone,
    });

    public static reelLandingShake = CustomWiggle.create("reelLandingShake", {
        wiggles:1,
        type:"easeOut"
    });

    public static bigWinAnticipationWiggle = CustomWiggle.create("bigWinAnticipationWiggle", {
        wiggles:60,
        amplitudeEase:Linear.easeNone,
        timingEase:Linear.easeNone,
    });

    public static periscopeHitWiggleX = CustomWiggle.create("periscopeHitWiggle", {
        wiggles:15,
        amplitudeEase:Linear.easeNone,
        timingEase:Linear.easeNone,
    });
    public static periscopeHitWiggleY = CustomWiggle.create("periscopeHitWiggle", {
        wiggles:10,
        amplitudeEase:Linear.easeNone,
        timingEase:Linear.easeNone,
    });

    public static avalancheBounceEase = CustomEase.create("custom", "M0,0 C0,0 0,0 0,0 0.222,0 0.392,0.963 0.4,1 0.4,1 0.474,0.984 0.548,0.984 0.624,0.984 0.7,1 0.7,1 0.7,1 0.75,0.99 0.8,0.99 0.85,0.99 0.9,1 0.9,1 0.9,1 0.931,0.995 0.942,0.995 0.956,0.995 1,1 1,1 ");

    public static xWayScaleEase:string = "elastic.out(1,0.75)";

    public static countEase = CustomEase.create("custom", "M0,0 C0.728,0.728 0.694,1 1,1 ");

    //Colors
    static glowFrameWinTint:number = PIXI.utils.string2hex("#ffe867");
    static torpedoWeldTint:number = PIXI.utils.string2hex("#6666ff");

    static mysteryRevealTint:number = PIXI.utils.string2hex("#5af2ff");


    static winHighlightTint:number = PIXI.utils.string2hex("#fff2a9");

    static nearWinTint:number = PIXI.utils.string2hex("#00ff00");
    static periscopeNearWinTint:number = PIXI.utils.string2hex("#ff0000");
    static periscopeNearWinFrameTint:number = PIXI.utils.string2hex("#ffc533");


    static frameTintWin:number = PIXI.utils.string2hex("#ffffff");
    static frameTintNormal:number = PIXI.utils.string2hex("#000000");


    static torpedoPartTintXWays:number = PIXI.utils.string2hex("#6478ff");
    static torpedoPartTintWild:number = PIXI.utils.string2hex("#ff6464");
    static noWinTint:number = PIXI.utils.string2hex("#000000");

}

export enum VignetteTint {
    GREEN = PIXI.utils.string2hex("#009900"),
    YELLOW = PIXI.utils.string2hex("#cbb000"),
    RED = PIXI.utils.string2hex("#d60000"),
}